"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PanelNoData = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styles = {
    container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        userSelect: 'none',
        width: '100%',
        height: '100%',
        paddingLeft: '2em',
        paddingRight: '2em',
    },
    text: {
        padding: '1.2em 2em',
        backgroundColor: '#f7f7f7',
        borderRadius: '2em',
        color: '#2d2d2d',
        fontWeight: 'bold',
    },
};
function PanelNoData({ children }) {
    return ((0, jsx_runtime_1.jsx)("div", { style: styles.container, children: (0, jsx_runtime_1.jsx)("p", { style: styles.text, children: children }) }));
}
exports.PanelNoData = PanelNoData;
